import { render, staticRenderFns } from "./OrdemDeCompraDetalhe.vue?vue&type=template&id=42579836&"
import script from "./OrdemDeCompraDetalhe.vue?vue&type=script&lang=js&"
export * from "./OrdemDeCompraDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports